import { reactive } from "vue";
import { v4 } from "uuid";
import { roomState } from "./room";

export const notifications = reactive<
  {
    id: string;
    text: string;
    icon?: string;
    canExit?: boolean;
    button?: {
      text: string;
      style?: "default-not-btn" | "blue-not-btn" | "white-not-btn";
      action: () => void;
    };
    clear: () => void
  }[]
>([]);
const notifyTimeouts = new Map<string, NodeJS.Timeout>()

export function addNotification(
  s: number,
  text: string,
  icon?: string,
  canExit = false,
  button?: { text: string; style?: "default-not-btn" | "blue-not-btn" | "white-not-btn"; action: () => void },
  cleared: () => void = () => {},
) {
  const id = v4();
  const clear = () => {
    const not = notifications.findIndex((n) => n.id === notification.id);
    if (not > -1) {
      notifications.splice(not, 1);
      cleared();
    }
  };
  const notification = {
    id,
    text,
    icon,
    canExit,
    button,
    clear
  };
  notifications.push(notification);
  if (s !== 0) {
    const timeout = setTimeout(() => {
      notifyTimeouts.delete(id)
      clear();
    }, 1000 * s);
    notifyTimeouts.set(id, timeout)
  }
  return notification.id;
}

export function addGarantedInCallNotification(
  s: number,
  text: string,
  icon?: string,
) {
  if (document.visibilityState === "visible" && roomState.status === "Active") {
    return addNotification(s, text, icon);
  } else {
    const int = setInterval(() => {
      if (
        document.visibilityState === "visible" &&
        roomState.status === "Active"
      ) {
        addNotification(s, text, icon);
        clearInterval(int);
      }
    }, 3000);
  }
}

export function removeNotification(id: string) {
  const not = notifications.findIndex((n) => n.id === id);
  if (not > -1) {
    notifications.splice(not, 1);
    notifyTimeouts.delete(id)
  }
}

export function clearAllNotifications() {
  notifications.length = 0;
  notifyTimeouts.forEach((timeout) => clearTimeout(timeout));
  notifyTimeouts.clear();
}

export function replaceNotification(id: string, text: string) {
  const not = notifications.findIndex((n) => n.id === id);
  if (not > -1) {
    notifications[not].text = text;
  }
}
